export default "__VITE_PUBLIC_ASSET__2335256e__"